import { useEffect, useState, useSyncExternalStore } from 'react';
import { WidgetFrame, type WidgetProps } from '@ayocore/platform/client/widgets';
import { useDealReportRepository } from '../../../rpc';
import { buildDealsListUrl } from '../shared/buildDealsListUrl';
import { DealStatusAmounts } from '../shared/DealStatusAmounts';
import { crmWidgetStyle } from '../shared/presentation';
import { BranchDealsWidgetController } from './BranchDealsWidgetController';

/** Суммы сделок филиала текущего пользователя по статусам. */
export function BranchDealsWidget({ title, className }: WidgetProps) {
  const repository = useDealReportRepository();
  const [controller] = useState(() => new BranchDealsWidgetController(repository));
  const { stats } = useSyncExternalStore(controller.subscribe, controller.getSnapshot);

  useEffect(() => {
    void controller.load();
    return () => controller.cancelLoad();
  }, [controller]);

  if (!stats) return null;

  return (
    <WidgetFrame
      title={title === undefined ? `Сделки филиала: ${stats.branchName}` : title}
      className={className}
      radius='lg'
      style={crmWidgetStyle}
    >
      <DealStatusAmounts
        items={stats.stats}
        getStatusUrl={statusId => buildDealsListUrl({ statusId, branchId: stats.branchId })}
      />
    </WidgetFrame>
  );
}
